import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { WyanokeUtil } from "../../util/WyanokeUtil";
import { PageContext } from "../../service/PageContext";
import { StringUtil } from "../../util/StringUtil";

export class LoginSignupSplash extends Component {

  constructor(element: HTMLElement, pageContext: PageContext) {
    super(element, pageContext);
  }

  public async init(): Promise<void> {
    const profile = await WyanokeUtil.loadUserProfile(true, false);

    if((profile?.isLoggedIn||"False") === "False") {
      this._element.querySelector(".trending-article")?.classList.add("d-none");
      this._element.querySelector(".login-signup")?.classList.remove("d-none");
      this._element.querySelectorAll(".btn").forEach(ele=>{
        const button = ele as HTMLButtonElement;
        button.addEventListener("click", ev => this.handleClick(ev));
      });
    } else {
      this._element.querySelector(".trending-article")?.classList.remove("d-none");
      this._element.querySelector(".login-signup")?.classList.add("d-none");
    }
  }

  public handleClick(evt:Event): void {
    const button = evt.target as HTMLButtonElement;
    console.log(`${button.innerHTML} clicked`);
    const sitename = this._element.dataset.sitename||"healiotwo";
    const contextid = this._element.dataset.contextid||"11111111-1111-1111-1111-111111111111";

    const values = {
      sitename,
      contextid
    };
    const reqUrl = StringUtil.supplant("/utilityapp/json/na/li/{sitename}/{contextid}", values) || "";

    // hate this, figure it out and fix it later..
    $.get(reqUrl,function (data){$('body').append(data);})
  }
}

ComponentFactory.registerComponent("LoginSignupSplash",LoginSignupSplash);
